// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"4d2ac5a5","171":"e3dfeb7c","432":"0c73fb35","994":"c8139faa"}[chunkId] + ".chunk.js";
};